import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { houseLabelKeyForPath, resolvePanelHomePath } from '@/application/navigation/menuHouses';
import { PanelPageState } from '@/presentation/components/common/PanelPageState';
import { usePermissions } from '@/presentation/contexts/permissionsContextCore';

function homeCtaLabel(homeTo: string, t: (key: string, opts?: { section?: string }) => string): string {
  const labelKey = houseLabelKeyForPath(homeTo);
  if (labelKey && labelKey !== 'menu.summary') {
    return t('common.pageStates.forbidden.goTo', { section: t(labelKey) });
  }
  return t('reports.comingSoon.back');
}

/** Bookmark de reporte `soon`: mensaje honesto, sin CTA a una pantalla que no existe. */
export function ComingSoonReportPage() {
  const { t } = useTranslation();
  const { hasPermission } = usePermissions();
  const homeTo = resolvePanelHomePath(hasPermission);

  return (
    <div
      className="flex h-full min-h-0 flex-1 items-center justify-center px-4 py-8 sm:px-6"
      data-testid="coming-soon-report-page"
    >
      <PanelPageState
        variant="empty"
        layout="page"
        title={t('reports.comingSoon.title')}
        message={t('reports.comingSoon.message')}
        action={
          <Link to={homeTo} className="panel-page-state__cta" data-testid="coming-soon-home">
            {homeCtaLabel(homeTo, t)}
          </Link>
        }
      />
    </div>
  );
}
